import PropTypes from 'prop-types';
import * as encadreStyles from '../../../styles/admissions/admissions.module.scss';

const Encadre = ({ children, ...props }) => {
  const color = props.color === 'primary' ? 'var(--red-color)' : 'var(--darker-white-color)';
  return (
    <div className={encadreStyles.encadre} style={{ border: `1px solid ${color}` }}>
      {children}
    </div>
  );
};

Encadre.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  color: PropTypes.oneOf(['primary', 'secondary']),
};

export default Encadre;
